import { WaterMinusOutlineIcon } from './WaterMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8536A2D7-1203-44B5-BBBE-6C37AABAD5B6
 * name water-minus-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-minus-outline.svg
 * tags
 */
export const InkMinusOutlineIcon = WaterMinusOutlineIcon;
export default InkMinusOutlineIcon